console.log('parent scripts included')

import { mainMenu, dropdownMenu } from "./menu";
import headerInit from "./header";
import { ready } from "./utils";
import { formEntry, formDuplicate } from "./form_entry";

import { gclid } from "./gclid";
import { readMore, loadMore, showMorePrograms, loadMoreReview } from "./show-more";
import { hvacSliders } from "./sliders";
import { modalDialog, adaModal } from "./modals";
import { signatureBlockAnimation } from "./animations";
import { cf7RedirectsAfterSubmit } from "./cf7-redirects-after-submit";
import { accordionFAQ, targetFaqItems } from "./accordion";
import { ScheduleEngineLoader } from "./loaders.js";
import { cf7SpecialTagsFix } from "./cf-7-special-tags-fix.js";

// import { tocAnchor } from './toc';
// import { sentNewMessage } from './thank-you-messages';
// import { downloadPdfCoupon } from "./coupon-download-pdf"; -- not in use and extends js file up to 600kb insted of 100kb

ready(() => {
  mainMenu();
  dropdownMenu();
  headerInit();
  formEntry();
  formDuplicate();
  // sentNewMessage('.sidebar-form');
  gclid();
  hvacSliders();
  readMore();
  loadMore();
  showMorePrograms();
  loadMoreReview();
  modalDialog();
  signatureBlockAnimation();
  cf7RedirectsAfterSubmit();
  accordionFAQ();
  adaModal();
  targetFaqItems();
  ScheduleEngineLoader();
  cf7SpecialTagsFix();
});

